import { FC, ReactNode } from 'react';

import { Card, Flex } from 'antd';
import classNames from 'classnames';

import useMobile from '@/hooks/use-mobile';

import { DisclaimerType } from './Disclaimer.types';
import { getIcon } from './Disclaimer.utils';

import styles from './Disclaimer.module.scss';

type Props = {
	text: string;
	type: DisclaimerType;
	actionInText?: boolean;
	action?: ReactNode;
};

export const Disclaimer: FC<Props> = ({ text, action, type, actionInText }) => {
	const { isMobile } = useMobile();
	return (
		<Card variant="borderless" className={classNames(styles.card, { [styles.mobile]: isMobile })}>
			<Flex
				vertical={isMobile}
				align="center"
				justify={actionInText ? 'flex-start' : 'space-between'}
				className={styles.cardBody}
				gap={8}
			>
				<Flex className={styles.text} align={isMobile ? 'start' : 'center'} gap={8}>
					<div className={styles.icon}>{getIcon(type)}</div>
					<div>{text}</div>
				</Flex>
				{action}
			</Flex>
		</Card>
	);
};
